function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "prefix__a",
  d: "M0 0H18V18H0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__a"
})), React.createElement("g", {
  stroke: "#0082FF",
  strokeWidth: 1.2,
  mask: "url(#prefix__b)"
}, React.createElement("g", null, React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.313 0H1.625C.728 0 0 .672 0 1.5v12c0 .828.728 1.5 1.625 1.5h9.75c.897 0 1.625-.672 1.625-1.5V5.25L7.312 0z",
  transform: "translate(2.5 1.5)"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7 0L7 6 13 6",
  transform: "translate(2.5 1.5)"
}), React.createElement("path", {
  d: "M2.859 8.986h7M2.859 10.986h4",
  transform: "translate(2.5 1.5)"
}))));

var SvgIcoDetails = function SvgIcoDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-details.73a4fc84.svg";
export { ForwardRef as ReactComponent };